/**
 * The Readdy "Diyafa Assistant" chat widget is a third-party script.
 * It belongs on the public marketing pages only: inside the app it sits
 * on top of form submit buttons and would run alongside guest data.
 *
 * It is injected on demand (see AppRoutes) instead of from index.html,
 * so a page load that starts inside /dashboard never fetches it.
 */
const WIDGET_SRC = "https://readdy.ai/api/public/assistant/widget?projectId=29d4a877-8ebe-47ef-91a9-40227308fb0d";

const WIDGET_ATTRS: Record<string, string> = {
  mode: "hybrid",
  "voice-show-transcript": "true",
  theme: "dark",
  position: "bottom-right",
  size: "compact",
  radius: "large",
  "accent-color": "#F59E0B",
  "button-base-color": "#78350F",
  "button-accent-color": "#FCD34D",
  "main-label": "Diyafa Assistant",
  "start-button-text": "Start Chat",
  "end-button-text": "End Call",
  "empty-chat-message": "Hi! I'm your Diyafa assistant. Ask me anything about the platform, hotel management, or Rasad compliance.",
};

let loaded = false;

export function loadChatWidget(): void {
  if (loaded) return;
  loaded = true;
  const script = document.createElement("script");
  script.src = WIDGET_SRC;
  script.defer = true;
  for (const [name, value] of Object.entries(WIDGET_ATTRS)) script.setAttribute(name, value);
  document.body.appendChild(script);
}

/** True once the widget has been injected during this page load. */
export function chatWidgetLoaded(): boolean {
  return loaded;
}
